import type { useUI } from '../components/overlays';
import { PasteForm } from './PasteForm';

/** Окно «Разобрать сообщение» для вакансии (или «Вставить текст» для новой). */
export function openPaste(ui: ReturnType<typeof useUI>, targetId: string | null, company?: string) {
  ui.openSheet({
    title: targetId ? `Сообщение · ${company || 'вакансия'}` : 'Вставить текст',
    body: <PasteForm targetId={targetId} />,
  });
}
